import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { SharedService } from '../services/shared.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) { }

canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
  let currentUser: any = null;

  if (typeof window !== "undefined") {
    try {
      const userDetails = localStorage.getItem('USER');
      currentUser = userDetails ? JSON.parse(userDetails) : null;
    } catch {
      currentUser = null;
    }
  }

  if (currentUser) return true;

  const safeRoutes: Record<string, string> = {
    en: '/en/error/401',
    ar: '/ar/error/401'
  };

  const lang = localStorage.getItem('LANGUAGE');
  const redirectUrl = safeRoutes[lang || ''] || safeRoutes['en'];

  if (isPlatformBrowser(this.platformId)) {
    this.sharedService.redirect(redirectUrl);
  }

  return false;
}

}